import { render } from "./loading-screen.vue?vue&type=template&id=7b0faca6&scoped=true"
import script from "./loading-screen.vue?vue&type=script&lang=js"
export * from "./loading-screen.vue?vue&type=script&lang=js"

import "./loading-screen.vue?vue&type=style&index=0&id=7b0faca6&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b0faca6"],['__file',"src/components/loading-screen.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b0faca6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b0faca6', __exports__)) {
    api.reload('7b0faca6', __exports__)
  }
  
  module.hot.accept("./loading-screen.vue?vue&type=template&id=7b0faca6&scoped=true", () => {
    api.rerender('7b0faca6', render)
  })

}


export default __exports__